var combineRefs = function combineRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  if (refs.length === 2) {
    return combineTwoRefs(refs[0], refs[1]) || null;
  }
  var combinedRef = refs.slice(1).reduce(function (semiCombinedRef, refToInclude) {
    return combineTwoRefs(semiCombinedRef, refToInclude);
  }, refs[0]);
  return combinedRef || null;
};
var combinedRefCache = new WeakMap();
var combineTwoRefs = function combineTwoRefs(ref1, ref2) {
  if (ref1 && ref2) {
    var ref1Cache = combinedRefCache.get(ref1) || new WeakMap();
    combinedRefCache.set(ref1, ref1Cache);
    var combinedRef = ref1Cache.get(ref2) || function (instance) {
      updateRef(ref1, instance);
      updateRef(ref2, instance);
    };
    ref1Cache.set(ref2, combinedRef);
    return combinedRef;
  }
  if (!ref1) {
    return ref2;
  } else {
    return ref1;
  }
};
var updateRef = function updateRef(ref, instance) {
  if (typeof ref === 'function') {
    ref(instance);
  } else {
    ref.current = instance;
  }
};
export default combineRefs;